import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/burger.svg';

export const IconBurger = createIconComponent(Icon);
